module.exports = __webpack_public_path__ + "img/arrow-left.6741b446.svg";